import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
import { UserType } from "types/UsersTypes";
import { AddUserType } from "types/UsersTypes";

export const useUpdateUser = (
  options?: UseMutationOptions<any, Error, UserType>
) => {
  return useMutation({
    mutationKey: ["suspend"],
    mutationFn: async (values: UserType & AddUserType) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("phonePrefixUuid", values.phonePrefixUuid);
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("email", values.email);
      formData.append("notifySuccessorAdded", String(Boolean(values.notifySuccessorAdded)));
      formData.append("isSendInvoice", String(Boolean(values.isSendInvoice)));


      if (values.rodoPreference) {
        formData.append("rodoPreference", values.rodoPreference);
      }

      if (values.file) {
        formData.append("file", values.file);
      }

      return axiosInstance
        .put(`users/admin/${values.uuid}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "suspend",
      });

      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zaktualizowano użytkownika",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "suspend",
      });
      queryClient.prefetchQuery({ queryKey: ["users"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      if (options && options.onError) {
        options.onError(error, variables, context);
      }

      if (error.data.message === "EMAIL_EXIST") {
        Toast({
          message: "Użytkownik z tym adresem e-mail już istnieje.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "suspend",
        });
      } else  if (error.data.message === "PHONE_NUMBER_EXIST") {
        Toast({
          message: "Użytkownik z tym numerem telefonu już istnieje.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "suspend",
        });
      } else if (error?.data?.errors?.[0]?.rule === "file.size") {
        Toast({
          message: "Plik jest zbyt duży, maksymalny rozmiar to 20MB.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "suspend",
        });
      } else {
        Toast({
          message: "Błąd podczas aktualizacji użytkownika.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "suspend",
        });
      }

      
    },
  });
};

export default useUpdateUser;
